export default __webpack_public_path__ + "static/junk-removal-single-e7a3872ec680ad2a4ab4779980f06adf.jpg";